"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _commonRichText = require("@mmc/common-rich-text");
var _commonAccordion = require("@mmc/common-accordion");
var _legalTextBlock = _interopRequireDefault(require("../styles/legal-text-block.css"));
var _legalTextBlock2 = _interopRequireDefault(require("./legal-text-block.props/legal-text-block.propTypes"));
/**
 * ## LegalTextBlock - component
 *
 * Some really cool piece of description goes here.
 */

var LegalTextBlock = function LegalTextBlock(_ref) {
  var data = _ref.data,
    theme = _ref.theme;
  // first we select the data from the larger query coming through
  var disclaimerList = data.disclaimerList,
    disclaimerLabel = data.disclaimerLabel,
    useAccordion = data.useAccordion,
    hideDisclaimer = data.hideDisclaimer,
    paragraph = data.paragraph;
  if (hideDisclaimer) return null;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, useAccordion && disclaimerLabel && /*#__PURE__*/_react["default"].createElement("div", {
    className: _legalTextBlock["default"].accordionWrapper
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(theme['col-xs-12'], theme['col-md-12'], _legalTextBlock["default"].noPadding)
  }, /*#__PURE__*/_react["default"].createElement(_commonAccordion.CommonAccordion, {
    theme: theme,
    borderStyle: "top",
    expectedPanelHeight: "xl"
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, disclaimerLabel), /*#__PURE__*/_react["default"].createElement("div", null, paragraph && /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
    theme: theme,
    format: "legal",
    html: paragraph
  }), Array.isArray(disclaimerList) && /*#__PURE__*/_react["default"].createElement("div", {
    className: _legalTextBlock["default"].disclaimerList
  }, disclaimerList.map(function (disclaimer) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: disclaimer.associated,
      className: _legalTextBlock["default"].itemDisclaimer
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _legalTextBlock["default"].disclaimerNumber
    }, disclaimer.disclaimerNumber), /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
      theme: theme,
      format: "legal",
      html: disclaimer.disclaimerContent
    }));
  }))))))), !useAccordion && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(theme['container-fluid'], _legalTextBlock["default"].wrapper)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(theme.row, _legalTextBlock["default"].fullWidth)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(theme['col-xs-12'], theme['col-sm-1'])
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(theme['col-xs-12'], theme['col-sm-8'])
  }, /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
    theme: theme,
    format: "legal",
    html: paragraph
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(theme['col-xs-12'], theme['col-sm-3'])
  }))));
};
LegalTextBlock.displayName = 'LegalTextBlock';

// All components need a resourceType in order for AEM to be aware of its existence
LegalTextBlock.resourceType = function () {
  return 'LegalTextBlock_1_0_0';
};
var _default = LegalTextBlock;
exports["default"] = _default;